import { graphql, useStaticQuery } from "gatsby"
import React from "react"
import { css } from "styled-components"
import Hero from "../../../components/shared/hero"

const useHeroImages = () => {
  const query = useStaticQuery(graphql`
    query {
      lg: file(
        relativePath: {
          eq: "1_SOLUTIONS/Mapping CMS - Internal Pages/Indoor Positioning/hero/hero 1440.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 1920) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      md: file(
        relativePath: {
          eq: "1_SOLUTIONS/Mapping CMS - Internal Pages/Indoor Positioning/hero/hero 768.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      sm: file(
        relativePath: {
          eq: "1_SOLUTIONS/Mapping CMS - Internal Pages/Indoor Positioning/hero/hero 360.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  const images = Object.keys(query).reduce((acc, current) => {
    acc[current] = query[current].childImageSharp.fluid
    return acc
  }, {})

  return images
}

const HeroOverlay = css`
  mix-blend-mode: multiply;
`

const IndoorPositioningHero = ({ title, description }) => {
  const images = useHeroImages()

  return (
    <Hero
      overlayStyle={HeroOverlay}
      sizes={images}
      title={title}
      description={description}
    />
  )
}

export default IndoorPositioningHero
